function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_42339_5793)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.49984 17.666C7.59189 17.666 7.6665 17.5914 7.6665 17.4993C7.6665 17.4073 7.59189 17.3327 7.49984 17.3327C7.40779 17.3327 7.33317 17.4073 7.33317 17.4993C7.33317 17.5914 7.40779 17.666 7.49984 17.666ZM5.6665 17.4993C5.6665 16.4868 6.48731 15.666 7.49984 15.666C8.51236 15.666 9.33317 16.4868 9.33317 17.4993C9.33317 18.5119 8.51236 19.3327 7.49984 19.3327C6.48731 19.3327 5.6665 18.5119 5.6665 17.4993Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6668 17.666C16.7589 17.666 16.8335 17.5914 16.8335 17.4993C16.8335 17.4073 16.7589 17.3327 16.6668 17.3327C16.5748 17.3327 16.5002 17.4073 16.5002 17.4993C16.5002 17.5914 16.5748 17.666 16.6668 17.666ZM14.8335 17.4993C14.8335 16.4868 15.6543 15.666 16.6668 15.666C17.6794 15.666 18.5002 16.4868 18.5002 17.4993C18.5002 18.5119 17.6794 19.3327 16.6668 19.3327C15.6543 19.3327 14.8335 18.5119 14.8335 17.4993Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.166504 0.833984C-0.166504 0.2817 0.281211 -0.166016 0.833496 -0.166016H4.16683C4.64346 -0.166016 5.05384 0.17037 5.14738 0.637727L5.82047 4.00065H19.1668C19.4649 4.00065 19.7473 4.13358 19.9373 4.36321C20.1273 4.59283 20.205 4.89523 20.1491 5.18798L18.8144 12.1871C18.6924 12.801 18.3585 13.3524 17.8709 13.7449C17.3862 14.1351 16.7804 14.3434 16.1584 14.334H8.07526C7.45328 14.3434 6.84745 14.1351 6.36272 13.7449C5.87547 13.3526 5.54162 12.8016 5.41953 12.1882C5.41946 12.1878 5.41939 12.1875 5.41932 12.1871L4.02826 5.23701C4.02202 5.21126 4.01677 5.18511 4.01257 5.15863L3.34715 1.83398H0.833496C0.281211 1.83398 -0.166504 1.38627 -0.166504 0.833984ZM6.22077 6.00065L7.381 11.7975C7.41148 11.951 7.49497 12.0888 7.61685 12.1869C7.73873 12.285 7.89123 12.3372 8.04767 12.3342L8.06683 12.334H16.1668L16.186 12.3342C16.3424 12.3372 16.4949 12.285 16.6168 12.1869C16.7379 12.0894 16.8211 11.9527 16.8521 11.8004C16.8523 11.7994 16.8525 11.7985 16.8527 11.7975L17.9581 6.00065H6.22077Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_42339_5793"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#29394D",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.be4b0d5e.svg";
export { ForwardRef as ReactComponent };